import React from 'react';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { Intro } from '@/components/Intro';
import { Entorn } from '@/components/Entorn';
import { Edicions } from '@/components/Edicions';
import { Contact } from '@/components/Contact';
import { Sponsors } from '@/components/Sponsors';
import { Footer } from '@/components/Footer';
import { GraciesModal } from '@/components/GraciesModal';

// Portada de fuera de temporada. La edición 2026 ya pasó: el mapa de
// localizaciones y la agenda con el buscador no se pintan aquí.
//
// Los componentes (MapSection, Agenda, ShowCard, ShowModal) y los datos de los
// espectáculos siguen en el repositorio: los reutiliza la página de ediciones
// anteriores. Para devolver la agenda a la portada basta con volver a
// importarla aquí.
export default function HomePage() {
  return (
    <div className="relative min-h-screen bg-[#040f0c] text-white">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <Entorn />
        <Edicions />
        <Contact />
      </main>
      <Sponsors />
      <Footer />
      {/* Missatge d'agraïment de final d'edició. No pinta res si el bloc
          "gracies" de festivalData.json està desactivat. */}
      <GraciesModal />
    </div>
  );
}
